import React from 'react';
import propTypes from 'prop-types';

import './style.css';

import * as navigator from '../../../../native/navigator';
import { sendStatsEvent } from '../../../../components/statistics/index';
import { isShare } from '../../from';

EditButton.propTypes = {
  day: propTypes.number.isRequired,
  trip:propTypes.object.isRequired
};


export default function EditButton(props) {
  let {day, trip} = props;
  let tjKey = Number(day) === 0 ? 2 : 3;
  day = Number(day) === 0 ? 1 : day;
  return (
    <div 
      className='edit-button'
      onClick={() => {
        sendStatsEvent(`trip_Edit_click_${tjKey}`);
        if(isShare()) return;
        navigator.push('/m/v2/?m=render2&page=trip-edit2', {
          day,
          trip_id: trip.trip_id
        });
      }}>
      <i className="icon icon-edit"></i>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/EditButton2/index.js